module.exports = __webpack_public_path__ + "static/house_render_1-c415c774e94b0ce170183e79b55ad0f8.jpg";